// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { QuestRoute } from '../_common/api/QuestRoutes';
import { generateId } from '../_common/api/utility';
import Select from '../_common/form/Select';
import Loading from '../_common/Loading';
import ProductCard from './ProductCard';
import { HamQuest } from '../../App';

const ItemList = ({ items, ...props }) => {
    const { search } = useLocation();
    const location = new URLSearchParams(search)
    const [listItems, setListItems] = useState(items);
    const [loc, setLoc] = useState([]);
    const [locFilter, setLocFilter] = useState(location.get('location') || 0);

    useEffect(() => {
        HamQuest.get(QuestRoute.locations, { cache: 'force-cache' })
            .then((res) => setLoc(
                res.map(e => {
                    return {
                        label: e.city,
                        value: e.id
                    }
                })
            ))

        setListItems(items)
    }, [items])

    return (
        <div>
            <Select
                standalone
                label='Locations'
                options={
                    [
                        { label: 'All Locations', value: 0 },
                        loc
                    ].flat()
                }
                value={locFilter}
                onChange={(e) => setLocFilter(e.target.value)}
                style={{ justifyContent: 'flex-end' }}
            />
            {
                loc.length ?
                    ((
                        parseInt(locFilter) !== 0 ? listItems
                            .filter(e =>
                                ~e.locations.indexOf(parseInt(locFilter))
                            ) :
                            listItems
                    )
                        .sort((a, b) => b.price - a.price)
                        .map(e =>
                            <ProductCard
                                key={generateId()}
                                id={generateId()}
                                title={e.name}
                                price={e.price}
                                color={`rgb(${e.logo.red}, ${e.logo.green}, ${e.logo.blue}, ${e.logo.alpha})`}
                                image={e.logo.imageIndex}
                                details={e.details}
                                item={e}
                            />
                        )) : <Loading />
            }
        </div>
    );
}

export default ItemList;